import { Grid, TextField, Typography } from '@material-ui/core'
import Checkbox from '@material-ui/core/Checkbox'
import { Autocomplete } from 'components/Autocomplete'
import { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { SelecionarData } from 'components'
import { SelectSetor } from 'components/SelectSetor'
import { SelectUsuarios } from 'components/SelectUsuarios'
import { WrapperFiltros } from 'components/WrapperFiltros'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'
import { useFilter } from 'hooks/useFilter'
import { useSetorService } from 'hooks/useSetorService'
import { useTipoExameService } from 'hooks/useTipoExameService'
import useStyles from './styles'

export const FiltrosBancoExames = (props) => {
  const { setExames, setProcessandoExames } = props
  const setorService = useSetorService()
  const {
    filtroExameSetores,
    setFiltroExameSetores,
    filtroExameTipos,
    setFiltroExameTipos,
    filtroExameStatus,
    setFiltroExameStatus,
    filtroExameUsuarioRequisitante,
    setFiltroExameUsuarioRequisitante,
    filtroExameDataSolicitacaoInicio,
    setFiltroExameDataSolicitacaoInicio,
    filtroExameDataSolicitacaoFinal,
    setFiltroExameDataSolicitacaoFinal,
    filtroExameDataSolicitacaoChecked,
    setFiltroExameDataSolicitacaoChecked,
    filtroExameDataCriacaoInicio,
    setFiltroExameDataCriacaoInicio,
    filtroExameDataCriacaoFinal,
    setFiltroExameDataCriacaoFinal,
    filtroExameDataCriacaoChecked,
    setFiltroExameDataCriacaoChecked,
    filtroExameDataAtribuicaoInicio,
    setFiltroExameDataAtribuicaoInicio,
    filtroExameDataAtribuicaoFinal,
    setFiltroExameDataAtribuicaoFinal,
    filtroExameDataAtribuicaoChecked,
    setFiltroExameDataAtribuicaoChecked,
    filtroExameDataFinalizacaoInicio,
    setFiltroExameDataFinalizacaoInicio,
    filtroExameDataFinalizacaoFinal,
    setFiltroExameDataFinalizacaoFinal,
    filtroExameDataFinalizacaoChecked,
    setFiltroExameDataFinalizacaoChecked,
    filtroExameExaminadores,
    setFiltroExameExaminadores,
    filtroExameNumeroProcedimento,
    setFiltroExameNumeroProcedimento,
    filtroExameNumeroDocumento,
    setFiltroExameNumeroDocumento,
    filtroExameDataPublicacaoInicio,
    setFiltroExameDataPublicacaoInicio,
    filtroExameDataPublicacaoFinal,
    setFiltroExameDataPublicacaoFinal,
    filtroExameDataPublicacaoChecked,
    setFiltroExameDataPublicacaoChecked,
  } = useFilter()

  const tipoExameService = useTipoExameService()
  const classes = useStyles()
  const exameRealizadoService = useExameRealizadoService()
  const setores = useSelector((state) => state.options.setores)

  const [tiposExames, setTiposExames] = useState([])
  const [processandoOptions, setProcessandoOptions] = useState(false)

  useEffect(() => {
    const fetchOptions = async () => {
      if (!setores) {
        setorService.listarSetoresGlobal(setProcessandoOptions)
      }
      const tipos = await tipoExameService.listarTiposExamesAsync(setProcessandoOptions)
      setTiposExames(tipos)
    }
    fetchOptions()
  }, [])

  useEffect(() => {
    filtrarExames()
  }, [])

  const filtrarExames = useCallback(async () => {
    const dados = {
      setores: filtroExameSetores,
      tipos: filtroExameTipos,
      status: filtroExameStatus,
      usuarioRequisitante: filtroExameUsuarioRequisitante,
      dataSolicitacaoInicio: filtroExameDataSolicitacaoInicio,
      dataSolicitacaoFinal: filtroExameDataSolicitacaoFinal,
      dataSolicitacaoChecked: filtroExameDataSolicitacaoChecked,
      dataCriacaoInicio: filtroExameDataCriacaoInicio,
      dataCriacaoFinal: filtroExameDataCriacaoFinal,
      dataCriacaoChecked: filtroExameDataCriacaoChecked,
      dataAtribuicaoInicio: filtroExameDataAtribuicaoInicio,
      dataAtribuicaoFinal: filtroExameDataAtribuicaoFinal,
      dataAtribuicaoChecked: filtroExameDataAtribuicaoChecked,
      dataFinalizacaoInicio: filtroExameDataFinalizacaoInicio,
      dataFinalizacaoFinal: filtroExameDataFinalizacaoFinal,
      dataFinalizacaoChecked: filtroExameDataFinalizacaoChecked,
      examinadores: filtroExameExaminadores,
      numeroProcedimento: filtroExameNumeroProcedimento,
      numeroDocumento: filtroExameNumeroDocumento,
      dataPublicacaoInicio: filtroExameDataPublicacaoInicio,
      dataPublicacaoFinal: filtroExameDataPublicacaoFinal,
      dataPublicacaoChecked: filtroExameDataPublicacaoChecked,
    }
    const response = await exameRealizadoService.listarExamesRealizadosFiltradosAsync(dados, setProcessandoExames)
    setExames(response)
  }, [
    filtroExameSetores,
    filtroExameTipos,
    filtroExameStatus,
    filtroExameUsuarioRequisitante,
    filtroExameDataSolicitacaoInicio,
    filtroExameDataCriacaoInicio,
    filtroExameDataCriacaoFinal,
    filtroExameDataCriacaoChecked,
    filtroExameDataAtribuicaoFinal,
    filtroExameDataAtribuicaoInicio,
    filtroExameDataSolicitacaoFinal,
    filtroExameDataFinalizacaoChecked,
    filtroExameDataFinalizacaoInicio,
    filtroExameDataFinalizacaoFinal,
    filtroExameExaminadores,
    filtroExameNumeroProcedimento,
    filtroExameNumeroDocumento,
    filtroExameDataSolicitacaoChecked,
    filtroExameDataAtribuicaoChecked,
    filtroExameDataPublicacaoInicio,
    filtroExameDataPublicacaoFinal,
    filtroExameDataPublicacaoChecked,
  ])

  const handleChangeFiltroDataSolicitacaoInicio = (valor) => {
    if (valor !== 'Invalid date') setFiltroExameDataSolicitacaoInicio(valor)
  }
  const handleChangeFiltroDataSolicitacaoFinal = (valor) => {
    if (valor !== 'Invalid date') setFiltroExameDataSolicitacaoFinal(valor)
  }
  const handleChangeFiltroDataAtribuicaoInicio = (valor) => {
    if (valor !== 'Invalid date') setFiltroExameDataAtribuicaoInicio(valor)
  }
  const handleChangeFiltroDataAtribuicaoFinal = (valor) => {
    if (valor !== 'Invalid date') setFiltroExameDataAtribuicaoFinal(valor)
  }
  const handleChangeFiltroDataCriacaoInicio = (valor) => {
    if (valor !== 'Invalid date') setFiltroExameDataCriacaoInicio(valor)
  }
  const handleChangeFiltroDataCriacaoFinal = (valor) => {
    if (valor !== 'Invalid date') setFiltroExameDataCriacaoFinal(valor)
  }
  const handleChangeFiltroDataFinalizacaoInicio = (valor) => {
    if (valor !== 'Invalid date') setFiltroExameDataFinalizacaoInicio(valor)
  }
  const handleChangeFiltroDataFinalizacaoFinal = (valor) => {
    if (valor !== 'Invalid date') setFiltroExameDataFinalizacaoFinal(valor)
  }
  const handleChangeFiltroDataPublicacaoInicio = (valor) => {
    if (valor !== 'Invalid date') setFiltroExameDataPublicacaoInicio(valor)
  }
  const handleChangeFiltroDataPublicacaoFinal = (valor) => {
    if (valor !== 'Invalid date') setFiltroExameDataPublicacaoFinal(valor)
  }

  useEffect(() => {
    const dataAtual = new Date()
    dataAtual.setHours(0, 0, 0, 0)
    const dataDiaAnterior = new Date(dataAtual.getTime())
    dataDiaAnterior.setDate(dataAtual.getDate() - 1)
    if (!filtroExameDataSolicitacaoFinal) {
      setFiltroExameDataSolicitacaoInicio(dataDiaAnterior)
      setFiltroExameDataSolicitacaoFinal(dataAtual)
    }
    if (!filtroExameDataAtribuicaoFinal) {
      setFiltroExameDataAtribuicaoInicio(dataDiaAnterior)
      setFiltroExameDataAtribuicaoFinal(dataAtual)
    }
    if (!filtroExameDataCriacaoFinal) {
      setFiltroExameDataCriacaoInicio(dataDiaAnterior)
      setFiltroExameDataCriacaoFinal(dataAtual)
    }
    if (!filtroExameDataFinalizacaoFinal) {
      setFiltroExameDataFinalizacaoInicio(dataDiaAnterior)
      setFiltroExameDataFinalizacaoFinal(dataAtual)
    }
    if (!filtroExameDataPublicacaoFinal) {
      setFiltroExameDataPublicacaoInicio(dataDiaAnterior)
      setFiltroExameDataPublicacaoFinal(dataAtual)
    }
  }, [])

  const handleLimparFiltros = useCallback(async () => {
    setFiltroExameSetores([])
    setFiltroExameTipos([])
    setFiltroExameStatus([])
    setFiltroExameUsuarioRequisitante([])
    setFiltroExameDataSolicitacaoInicio(null)
    setFiltroExameDataAtribuicaoFinal(null)
    setFiltroExameDataAtribuicaoInicio(null)
    setFiltroExameDataSolicitacaoFinal(null)
    setFiltroExameDataFinalizacaoInicio(null)
    setFiltroExameDataFinalizacaoFinal(null)
    setFiltroExameExaminadores([])
    setFiltroExameNumeroProcedimento('')
    setFiltroExameNumeroDocumento('')
    setFiltroExameDataSolicitacaoChecked(false)
    setFiltroExameDataAtribuicaoChecked(false)
    setFiltroExameDataCriacaoChecked(false)
    setFiltroExameDataFinalizacaoChecked(false)
    setFiltroExameDataCriacaoInicio(null)
    setFiltroExameDataCriacaoFinal(null)
    setFiltroExameDataPublicacaoInicio(null)
    setFiltroExameDataPublicacaoFinal(null)
    setFiltroExameDataPublicacaoChecked(false)
    const dados = {
      setores: null,
      tipos: null,
      status: null,
      usuarioRequisitante: null,
      dataSolicitacaoInicio: null,
      dataSolicitacaoFinal: null,
      dataSolicitacaoChecked: false,
      dataCriacaoInicio: null,
      dataCriacaoFinal: null,
      dataCriacaoChecked: false,
      dataAtribuicaoInicio: null,
      dataAtribuicaoFinal: null,
      dataAtribuicaoChecked: false,
      dataFinalizacaoChecked: false,
      dataFinalizacaoInicio: null,
      dataFinalizacaoFinal: null,
      examinadores: null,
      numeroProcedimento: null,
      numeroDocumento: null,
      dataPublicacaoInicio: null,
      dataPublicacaoFinal: null,
      dataPublicacaoChecked: false,
    }
    const response = await exameRealizadoService.listarExamesRealizadosFiltradosAsync(dados, setProcessandoExames)
    setExames(response)
  }, [])

  return (
    <WrapperFiltros handleLimparFiltros={handleLimparFiltros} handleFiltrar={filtrarExames} disabledFiltrar={filtroExameDataSolicitacaoChecked && filtroExameDataSolicitacaoInicio > filtroExameDataSolicitacaoFinal}>
      <Grid item md={4} sm={12} xs={12} className={classes.grupoFiltros}>
        <Typography variant="subtitle2" className={classes.grupoTitle}>
          Dados do Exame
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} className={classes.item}>
            <Autocomplete
              value={filtroExameTipos}
              multiple
              name="tipos"
              options={tiposExames || []}
              onChange={(event, newValue) => setFiltroExameTipos(newValue)}
              label="TIPOS DE EXAME"
            />
          </Grid>
          <Grid item xs={12} className={classes.item}>
            <Autocomplete
              value={filtroExameStatus}
              multiple
              name="status"
              options={['Pendente', 'Em andamento', 'Finalizado', 'Publicado', 'Cancelado']}
              onChange={(event, newValue) => setFiltroExameStatus(newValue)}
              label="STATUS"
            />
          </Grid>
          <Grid item xs={12} className={classes.item}>
            <TextField fullWidth variant="outlined" label="NÚMERO DO PROCEDIMENTO" name="numeroProcedimento" onChange={(e) => setFiltroExameNumeroProcedimento(e.target.value)} value={filtroExameNumeroProcedimento || ''} InputLabelProps={{ shrink: true }} />
          </Grid>
          <Grid item xs={12} className={classes.item}>
            <TextField fullWidth label="NÚMERO DO DOCUMENTO" name="numeroDocumento" variant="outlined" onChange={(e) => setFiltroExameNumeroDocumento(e.target.value)} value={filtroExameNumeroDocumento || ''} InputLabelProps={{ shrink: true }} />
          </Grid>
        </Grid>
      </Grid>

      <Grid item md={4} sm={12} xs={12} className={classes.grupoFiltros}>
        <Typography variant="subtitle2" className={classes.grupoTitle}>
          Agentes e Setores
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} className={classes.item}>
            <SelectSetor setoresExternos={filtroExameSetores} setSetoresExternos={setFiltroExameSetores} setProcessando={setProcessandoOptions} label="SETORES" />
          </Grid>
          <Grid item xs={12} className={classes.item}>
            <SelectUsuarios usuariosExternos={filtroExameUsuarioRequisitante} setUsuariosExternos={setFiltroExameUsuarioRequisitante} setProcessando={setProcessandoOptions} label="AUTORIDADE SOLICITANTE" isFromBanco={true} multiplo={true} />
          </Grid>
          <Grid item xs={12} className={classes.item}>
            <SelectUsuarios usuariosExternos={filtroExameExaminadores} setUsuariosExternos={setFiltroExameExaminadores} setProcessando={setProcessandoOptions} label="EXAMINADOR" isFromBanco={true} multiplo={true} />
          </Grid>
        </Grid>
      </Grid>

      <Grid item md={4} sm={12} xs={12} className={classes.grupoFiltros}>
        <Typography variant="subtitle2" className={classes.grupoTitle}>
          Períodos
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} className={classes.itemData}>
            <Grid alignItems="center" container spacing={1}>
              <Grid item xs={2}>
                <Checkbox checked={filtroExameDataCriacaoChecked || false} onChange={(e) => setFiltroExameDataCriacaoChecked(e.target.checked)} />
              </Grid>
              <Grid item xs={5}>
                <SelecionarData dataBD={filtroExameDataCriacaoInicio} withoutTime callback={handleChangeFiltroDataCriacaoInicio} label="Criação - Início" disabled={!filtroExameDataCriacaoChecked} maxDate={filtroExameDataCriacaoFinal} />
              </Grid>
              <Grid item xs={5}>
                <SelecionarData dataBD={filtroExameDataCriacaoFinal} withoutTime callback={handleChangeFiltroDataCriacaoFinal} label="Criação - Final" disabled={!filtroExameDataCriacaoChecked} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.itemData}>
            <Grid alignItems="center" container spacing={1}>
              <Grid item xs={2}>
                <Checkbox checked={filtroExameDataSolicitacaoChecked || false} onChange={(e) => setFiltroExameDataSolicitacaoChecked(e.target.checked)} />
              </Grid>
              <Grid item xs={5}>
                <SelecionarData dataBD={filtroExameDataSolicitacaoInicio} withoutTime callback={handleChangeFiltroDataSolicitacaoInicio} label="Solicitação - Início" disabled={!filtroExameDataSolicitacaoChecked} maxDate={filtroExameDataSolicitacaoFinal} />
              </Grid>
              <Grid item xs={5}>
                <SelecionarData dataBD={filtroExameDataSolicitacaoFinal} withoutTime callback={handleChangeFiltroDataSolicitacaoFinal} label="Solicitação - Final" disabled={!filtroExameDataSolicitacaoChecked} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.itemData}>
            <Grid alignItems="center" container spacing={1}>
              <Grid item xs={2}>
                <Checkbox checked={filtroExameDataAtribuicaoChecked || false} onChange={(e) => setFiltroExameDataAtribuicaoChecked(e.target.checked)} />
              </Grid>
              <Grid item xs={5}>
                <SelecionarData dataBD={filtroExameDataAtribuicaoInicio} withoutTime callback={handleChangeFiltroDataAtribuicaoInicio} label="Atribuição - Início" disabled={!filtroExameDataAtribuicaoChecked} maxDate={filtroExameDataAtribuicaoFinal} />
              </Grid>
              <Grid item xs={5}>
                <SelecionarData dataBD={filtroExameDataAtribuicaoFinal} withoutTime callback={handleChangeFiltroDataAtribuicaoFinal} label="Atribuição - Final" disabled={!filtroExameDataAtribuicaoChecked} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.itemData}>
            <Grid alignItems="center" container spacing={1}>
              <Grid item xs={2}>
                <Checkbox checked={filtroExameDataFinalizacaoChecked || false} onChange={(e) => setFiltroExameDataFinalizacaoChecked(e.target.checked)} />
              </Grid>
              <Grid item xs={5}>
                <SelecionarData dataBD={filtroExameDataFinalizacaoInicio} withoutTime callback={handleChangeFiltroDataFinalizacaoInicio} label="Finalização - Início" disabled={!filtroExameDataFinalizacaoChecked} maxDate={filtroExameDataFinalizacaoFinal} />
              </Grid>
              <Grid item xs={5}>
                <SelecionarData dataBD={filtroExameDataFinalizacaoFinal} withoutTime callback={handleChangeFiltroDataFinalizacaoFinal} label="Finalização - Final" disabled={!filtroExameDataFinalizacaoChecked} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.itemData}>
            <Grid alignItems="center" container spacing={1}>
              <Grid item xs={2}>
                <Checkbox checked={filtroExameDataPublicacaoChecked || false} onChange={(e) => setFiltroExameDataPublicacaoChecked(e.target.checked)} />
              </Grid>
              <Grid item xs={5}>
                <SelecionarData dataBD={filtroExameDataPublicacaoInicio} withoutTime callback={handleChangeFiltroDataPublicacaoInicio} label="Publicação - Início" disabled={!filtroExameDataPublicacaoChecked} maxDate={filtroExameDataPublicacaoFinal} />
              </Grid>
              <Grid item xs={5}>
                <SelecionarData dataBD={filtroExameDataPublicacaoFinal} withoutTime callback={handleChangeFiltroDataPublicacaoFinal} label="Publicação - Final" disabled={!filtroExameDataPublicacaoChecked} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </WrapperFiltros>
  )
}
